<template>
  <ul class="icon-list">
    <li v-for="(item, index) in items" :key="index" class="list-element-with-icon">
      <img 
        :src="getIconSrc(item.icon)" 
        :alt="`${item.icon} icon`"
        class="line-icon"
        width="48"
        height="48"
      />
      <span class="text-wrapper">
        <span class="bold lead">{{ item.lead }}</span> <span class="text-content">{{ item.text }}</span>
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'IconList',
  props: {
    items: {
      type: Array,
      required: true,
      validator: (items) => {
        return items.every(item => 
          typeof item === 'object' && 
          'icon' in item && 
          'lead' in item && 
          'text' in item
        );
      }
    },
    color: {
      type: String,
      default: 'orange',
      validator: (value) => ['blue-bright', 'orange'].includes(value)
    }
  },
  methods: {
    getIconSrc(icon) {
      return `/assets/images/icon_${icon}_line-${this.color}.svg`;
    }
  }
}
</script>

<style lang="scss" scoped>
@use "@/assets/scss/abstracts/variables" as *;
@use "@/assets/scss/abstracts/mixins" as *;

.icon-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: $spacing-sm;
}

.list-element-with-icon {
  position: relative;
  list-style-image: none;
  list-style: none;
  padding-left: 0;
  //margin-bottom: 1rem;
  display: flex;
}

.line-icon {
  width: 3rem;
  height: 3rem;
  object-fit: contain;
  margin-bottom: 1rem;
}

.text-wrapper {
  padding-left: 1rem;
  
  .lead {
    font-weight: bold;
  }
}
</style> 